import React from 'react'
let vector = [1];

const Float = function float ({info}){
    return (
        <section>
            <div className="socialMob w80 flex">
                <a target="_blank" href={info.youtube}>
                    <img src={https+"img/social/yout.svg"} alt="youtube"/>
                </a>
                <a target="_blank" href={info.facebook}>
                    <img src={https+"img/social/face.svg"} alt="facebook"/>
                </a>
                <a target="_blank" href={info.instagram}>
                    <img src={https+"img/social/insta.svg"} alt="instagram"/>
                </a>
            </div>

            <div className="menuGtnd colflex">
            <p>&copy; 2021 Monster Car Audio.</p> <p>Todos los derechos reservados.</p>
                <a target="_blank" className="flex" href="https://www.gutand.com/">
                Creado por 
                <img src={https+"img/marca-gutand.svg"} alt="gutand"/>
                </a>
            </div>
            <div className="separatorMenu"></div>

            <div className="menuIcons flex">
                <a href={https} className="colflex">
                    <img src={https+"img/menuMob/home2.svg"} alt="🏠"/>
                    <p>Inicio</p>
                </a>
                <a href={https+"emptycart"} className="colflex cartMb">
                    <img src={https+"img/menuMob/cart2.svg"} alt="🛒"/>
                    <p>Carrito</p>
                    <span>{cantCart}</span>
                </a>        
                {vector.map((v) => {
                    if(nameUser == ""){
                        return (
                            <a key={1} href={https+"login"} className="colflex">
                                <img src={https+"img/menuMob/user2.svg"} alt="🙍‍♂️"/>
                                <p>Perfil</p>
                            </a>
                        )
                    }else{
                        return (
                            <a key={1} href={https+"profile"} className="colflex">
                                <img src={https+"img/menuMob/user2.svg"} alt="🙍‍♂️"/>
                                <p>Perfil</p>
                            </a>
                        )
                    }
                })}
            </div>

            <div className="floatW dnone">
                <a href="https://wa.me/573013959611" className="flex">
                    <img src={https+"img/flw.svg"} alt="📞"/>
                </a>
            </div>

            <div className="floatW2 dnone" id="showMenuPay">
                <a 
                    className="flex icono"
                >
                   $
                </a>
            </div>

            <div className="floatW2 dnone floatw3">
                <a 
                    href='https://www.paypal.me/monstercaraudio'
                    className="flex icono"
                    target="_blank"
                >
                   <img src={https+'img/icon/paypal-icon.png'} />
                </a>
            </div>

            <div className="floatW2 dnone floatw4">
                <a 
                    href='https://checkout.wompi.co/l/VPOS_mOF7nM'
                    className="flex icono"
                    target="_blank"
                >
                <img src={https+'img/icon/wompi_icon.png'} />
                </a>
            </div>

            <div class="flotante" id="floatshowMenuPay">
                <div class="colflex menu3">
                    <a href="https://www.paypal.me/monstercaraudio" target="_blank" class="flex enlace medium">
                        <p>Pagar con</p>
                        <img src={https+'img/paypal-logo.svg'} alt='img'/>
                    </a>
                    <a href="https://checkout.wompi.co/l/VPOS_mOF7nM" target="_blank" class="flex enlace">
                        <p>Pagar con</p>
                        <img src={https+'img/wompi_bancolombia.png'} alt='img'/>
                    </a>
                </div>
            </div>
        </section>
    )
}

export default Float